import React from 'react'
import PropTypes from 'prop-types'

const paymentMethod = appointment => {
  switch (appointment.dtoReservedAppointment.oneClickClientPaymentMethod) {
    case 'cash': return 'Dinheiro - Pagamento no Local'
    case 'bank_slip': return 'Boleto'
    case 'picpay': return 'PicPay'
    default: return 'Cartão de Crédito'
  }
}

const PaymentLabel = ({ appointment }) => (
  <span>{paymentMethod(appointment)}</span>
)
PaymentLabel.propTypes = {
  appointment: PropTypes.object.isRequired
}

export default PaymentLabel



// WEBPACK FOOTER //
// ./src/components/PaymentLabel/index.js